export const SITE = {
  name: "Kola Gebäudereinigung",
  short: "Kola",
  tagline: "Professionelle Gebäudereinigung in Bayern & Baden-Württemberg",
  phone: "0176 24458820",
  phoneHref: "tel:+4917624458820",
  email: "info@kola-reinigung.de",
  emailHref: "mailto:info@kola-reinigung.de",
  address: "Augsburger Str. 26, 86157 Augsburg",
  hoursWeek: "Mo – Fr: 08:00 – 18:00 Uhr",
  hoursSat: "Sa: nach Vereinbarung",
};

export const MEDIA = {
  hero: "https://images.pexels.com/photos/4239146/pexels-photo-4239146.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
  heroVideo: "/hero.mp4",
  heroVideoFallback: "/hero.mp4",
  services: {
    gebaeudereinigung:
      "https://images.pexels.com/photos/14408745/pexels-photo-14408745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    treppenhaus:
      "https://images.unsplash.com/photo-1771678040857-51d00a11be7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBicmlnaHQlMjBvZmZpY2UlMjBpbnRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzY4NzUzMjJ8MA&ixlib=rb-4.1.0&q=85",
    glas: "https://images.pexels.com/photos/634007/pexels-photo-634007.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    winterdienst:
      "https://images.pexels.com/photos/30079888/pexels-photo-30079888.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  team: "https://images.pexels.com/photos/9462636/pexels-photo-9462636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  reflection:
    "https://images.pexels.com/photos/33357392/pexels-photo-33357392.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    title: "Gebäudereinigung",
    desc: "Saubere, gepflegte und hygienische Räume – die Grundlage für Wohlbefinden und einen professionellen Auftritt. Regelmäßig oder einmalig, immer mit höchster Sorgfalt.",
    image: MEDIA.services.gebaeudereinigung,
    key: "gebaeudereinigung",
  },
  {
    title: "Treppenhausreinigung",
    desc: "Ein sauberes Treppenhaus ist die Visitenkarte eines Hauses. Zuverlässige, gleichbleibend hochwertige Reinigung für Bewohner und Besucher.",
    image: MEDIA.services.treppenhaus,
    key: "treppenhaus",
  },
  {
    title: "Glas- & Rahmenreinigung",
    desc: "Klare Fenster und saubere Rahmen lassen Räume heller und hochwertiger wirken. Streifenfreie Ergebnisse durch präzise Handarbeit.",
    image: MEDIA.services.glas,
    key: "glas",
  },
  {
    title: "Winterdienst",
    desc: "Wenn Schnee und Eis zum Problem werden, sind wir schnell zur Stelle. Sichere Wege, Zufahrten und Eingänge – einsatzbereit, wenn es darauf ankommt.",
    image: MEDIA.services.winterdienst,
    key: "winterdienst",
  },
];

export const BENEFITS = [
  { t: "Familiengeführt", d: "Persönlich erreichbar, ohne Umwege über Call-Center." },
  { t: "Erfahrung, die zählt", d: "Jahrelange Routine in professioneller Gebäudereinigung." },
  { t: "Individuelle Lösungen", d: "Maßgeschneidert statt Standardpaket – abgestimmt auf Ihr Objekt." },
  { t: "Zuverlässige Termine", d: "Pünktliche, saubere und gründliche Ausführung." },
  { t: "Freundlicher Service", d: "Klare Kommunikation und echter Qualitätsanspruch." },
  { t: "Privat & Gewerbe", d: "Für Haushalte, Unternehmen und Hausverwaltungen in Bayern und Baden-Württemberg." },
];

export const TESTIMONIALS = [
  {
    name: "Thomas M.",
    role: "Hausverwaltung Augsburg",
    text: "Sehr zuverlässiger Service und top Ergebnis. Seit Jahren unser fester Partner – immer pünktlich, immer makellos sauber.",
  },
  {
    name: "Sarah K.",
    role: "Privatkundin",
    text: "Schnelle Rückmeldung, freundlicher Kontakt und gründliche Arbeit. Bei der Fensterreinigung konnte man sich wortwörtlich drin spiegeln.",
  },
  {
    name: "Michael S.",
    role: "Büroleitung",
    text: "Professionell, pünktlich und sauber – genau so wünscht man sich das. Die Gebäudereinigung läuft geräuschlos und extrem zuverlässig.",
  },
];

export const PROCESS = [
  { n: "01", t: "Anfrage senden", d: "Kontaktieren Sie uns telefonisch oder über das Formular und schildern Sie Ihr Anliegen." },
  { n: "02", t: "Beratung erhalten", d: "Wir melden uns zeitnah zurück und besprechen die passende Lösung für Ihr Objekt." },
  { n: "03", t: "Reinigung starten", d: "Unser Team übernimmt die Reinigung professionell, zuverlässig und termingerecht." },
];

export const FAQS = [
  {
    q: "Welche Regionen bedienen Sie?",
    a: "Wir sind in Bayern und Baden-Württemberg für private und gewerbliche Kunden im Einsatz.",
  },
  {
    q: "Bieten Sie auch regelmäßige Reinigungen an?",
    a: "Ja, wir bieten sowohl einmalige Einsätze als auch feste Reinigungsintervalle – wöchentlich, zweiwöchentlich oder nach Bedarf.",
  },
  {
    q: "Wie schnell bekomme ich ein Angebot?",
    a: "In der Regel melden wir uns innerhalb eines Werktages nach Ihrer Anfrage mit einem unverbindlichen Angebot zurück.",
  },
  {
    q: "Arbeiten Sie auch für Unternehmen und Hausverwaltungen?",
    a: "Ja. Wir betreuen private Haushalte, Unternehmen, Hausverwaltungen und Objekte mit wiederkehrendem Reinigungsbedarf.",
  },
];
